// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__PR1IZ","colMin":"styles_colMin__yeuT1","colCheckbox":"styles_colCheckbox__2OIw7"};